<template>
  <div>
    <div class="display_flex top" style="margin-bottom: 10px">
      <el-button @click="goBack" type="info"> 返回 </el-button>
    </div>
    <el-table
      class="tables"
      v-loading="loading"
      :data="tableData"
      row-key="id"
      size="small"
      stripe
      border
    >
      <el-table-column fixed="left" label="操作" width="70" align="center">
        <el-icon :size="20" class="drag_btn">
          <Rank />
        </el-icon>
      </el-table-column>
      <el-table-column
        width="80"
        prop="out_sort"
        align="center"
        label="出库顺序"
      >
        <template #default="scope">
          <span>{{ scope.row.out_sort + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        width="200"
        prop="name"
        label="名称"
        show-overflow-tooltip
      >
        <template #default="scope">
          <span>{{ scope.row.drug.name }}</span>
        </template>
      </el-table-column>
      <el-table-column
        width="150"
        property="drug.medi_spec"
        label="规格"
        show-overflow-tooltip
      />
      <el-table-column width="120" align="center" label="包装">
        <template #default="scope">
          {{ scope.row.drug.min_package_num }}
          {{ scope.row.drug.min_unit_name }} /
          {{ scope.row.drug.min_package_unit_name }}
        </template>
      </el-table-column>
      <el-table-column
        width="150"
        property="drug.company"
        label="厂家"
        show-overflow-tooltip
      />
      <el-table-column width="150" prop="order_no" label="入库单号" />
      <el-table-column
        width="120"
        prop="batch_no"
        label="批号"
        show-overflow-tooltip
      />
      <el-table-column label="采购数量" width="120" align="center">
        <template #default="scope">
          <el-tag effect="dark">
            {{ scope.row.enter_num }} {{ scope.row.drug.min_package_unit_name }}
            <template v-if="scope.row.enter_sub_num"
              >{{ scope.row.enter_sub_num }}
              {{ scope.row.drug.min_unit_name }}</template
            >
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="库存数量" width="120" align="center">
        <template #default="scope">
          <el-tag effect="dark">
            {{ scope.row.store_num }} {{ scope.row.drug.min_package_unit_name }}
            <template v-if="scope.row.store_sub_num"
              >{{ scope.row.store_sub_num }}
              {{ scope.row.drug.min_unit_name }}</template
            >
          </el-tag>
        </template>
      </el-table-column>
      <!-- 入库单价 -->
      <el-table-column label="采购价" width="80">
        <template #default="scope">
          <span>{{ scope.row.buy_price }}元</span>
        </template>
      </el-table-column>
      <!-- 入库总额 -->
      <el-table-column label="采购总价" width="100">
        <template #default="scope">
          <span>{{ scope.row.total_buy_price }}元</span>
        </template>
      </el-table-column>
      <el-table-column width="80" label="零售价">
        <template #default="scope">
          <span>{{ scope.row.price }}元</span>
        </template>
      </el-table-column>
      <el-table-column width="100" label="零售总价">
        <template #default="scope">
          <span>{{ scope.row.total_sell_price }}元</span>
        </template>
      </el-table-column>
      <el-table-column
        width="110"
        prop="validity_end_time"
        align="center"
        label="到期时间"
        show-overflow-tooltip
      />
      <el-table-column
        width="110"
        prop="supplier"
        label="供应商"
        show-overflow-tooltip
      />
      <el-table-column
        width="100"
        prop="remark"
        label="备注"
        align="center"
        show-overflow-tooltip
      />
      <el-table-column
        width="180"
        prop="enter_time"
        align="center"
        label="入库时间"
      />
      <el-table-column
        width="80"
        property="operator.name"
        label="入库人"
        align="center"
      />
      <el-table-column fixed="right" label="操作" align="center" width="220">
        <template #default="scope">
          <el-link v-if="scope.row.check_status == 2" type="primary" @click="setPrice(scope.row)">调价</el-link>
          <el-link v-if="scope.row.check_status == 2" type="primary" @click="setPriceRecord(scope.row)">调价记录</el-link
          >
        </template>
      </el-table-column>
    </el-table>

    <setPriceRecordDialog
      ref="setPriceRecordDialogRef"
      @refreshDataList="getTableData"
    ></setPriceRecordDialog>
    <setPriceDialog ref="setPriceDialogRef" @refreshDataList="getTableData"></setPriceDialog>
  </div>
</template>
<script setup>
import { ref, defineExpose, defineEmits, onMounted, getCurrentInstance } from 'vue'
import service from '@/utils/request'
import Sortable from 'sortablejs'
import setPriceRecordDialog from './rk/setPriceRecord'
import setPriceDialog from './rk/setPrice'

let { proxy } = getCurrentInstance()

onMounted(() => {
  const el = document.querySelector(
    '.tables .el-table__body-wrapper  table tbody'
  )
  Sortable.create(el, {
    animation: 150,
    ghostClass: 'blue-background-class',
    handle: '.drag_btn', // 如果需要点击某个图标拖拽的话需要吧那个图标的class写在这里
    // 写完以上部分就已经可以实现基本的拖拽功能了，以下是拓展
    //始拖拽事件
    onEnd: function (evt) {
      let newIndex = evt.newIndex // 排序后的索引位置
      let oldIndex = evt.oldIndex // 排序前的索引位置
      var itemEl = evt.item // 拖拽 HTMLElement
      evt.to // 目标表
      evt.from // 上一个列表
      evt.oldIndex // 元素在旧父级中的旧索引
      evt.newIndex // 元素在新父级中的新索引
      evt.clone // 克隆元件
      evt.pullMode // 当项目在另一个可排序表中时：`“clone”`如果克隆，`true`如果移动

      setOutSort(tableData.value[oldIndex].id, newIndex)
      console.log(evt)
    },
    //点击选中元素事件
    onChoose: function (evt) {
      evt.oldIndex
    },
    //取消选中事件
    onUnchoose: function (evt) {},
  })
})

//修调价格
const setPrice = (row) => {
  proxy.$refs.setPriceDialogRef.initData(row)
}
//修调记录
const setPriceRecord = async (row) => {
    proxy.$refs.setPriceRecordDialogRef.initData(row)
}

const emit = defineEmits(['closeStoreDetail'])
const loading = ref(false)
const pageData = ref({
  dict_catalog_type: '',
  drug_id: 0,
  current: 0,
  size: 10,
})
const tableData = ref([])

const initData = (storeRow) => {
  tableData.value = []
  pageData.value.store = 1
  pageData.value.current = 0

  pageData.value.drug_id = storeRow.id

  getTableData()
}

// 修改出库顺序
const setOutSort = async (recordId, outSort) => {
  loading.value = true
  let data = {
    record_id: recordId,
    out_sort: outSort,
  }
  let res = await service.post('/api/storeEnterRecord/changeOutSort', data)
  if (res.code === 0) {
    getTableData()
  }
  loading.value = false
}

const getTableData = async () => {
  loading.value = true
  let res = await service.post(
    '/api/store_enter_record/get_enter_record_list',
    pageData.value
  )
  if (res.code === 0) {
    tableData.value = res.data.records
  }
  loading.value = false
}

//点击返回
const goBack = () => {
  emit('closeStoreDetail')
}

defineExpose({
  setPriceRecord,
  initData,
  getTableData,
  pageData,
  goBack,
  setOutSort,
})
</script>